import React from 'react'
import CarShowroomPage2B from './CarShowRoomPage2B'
import Hero4 from './Hero4'

const CarShowRoomPage2 = () => {
  return (
    <div>
        <Hero4/>
      <CarShowroomPage2B/>
    </div>
  )
}

export default CarShowRoomPage2
